<template lang="pug">
  .Ops
    top-information
    tabs-bar
    tabs-bar.top(:class="tabsBarVisible")
    advatage
    ability
    solutions
  
</template>

<script>
  import TopTitle from "@/components/topTitle";
  import TopInformation from "@/views/Ops/TopInformation/index";
  import TabsBar from "@/views/Ops/TabsBar/index";
  import Advatage from "@/views/Ops/advantage/index";
  import Ability from "@/views/Ops/ability/index";
  import Solutions from "@/views/Ops/solutions/index";
  import BottomFooter from "@/components/bottomFooter";
  export default {
    name: "Ops",
    components: {BottomFooter, Solutions, Ability, Advatage, TabsBar, TopInformation, TopTitle},
    data() {
      return {
        scrollY: 0,
      }
    },
    watch: {
      $route(val, newVal) {
        this.$children.forEach(child => {
          child.isShow = false;
          child.contentIsShow = false;
          setTimeout(() => {child.scrollTop = window.scrollY;}, 100);
        });
      }
    },
    computed: {
      tabsBarVisible() {
        if (this.scrollY > (600)) {
          return 'visible'
        }
        return 'invisible'
      },
    },
    mounted() {
      window.addEventListener('scroll', () => this.scrollY = window.scrollY);
    },
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .Ops {
    position relative
    VStack(center)
    background-color white
    min-width 1392px
    overflow auto
  }
  .top {
    position fixed
    top 0
    left 0
    z-index 1
  }
  .invisible {
    visibility hidden
  }
  .visible {
    visibility visible
  }
  @media (max-width ipadProScreenWidth) {
    .Ops {
      width 100vw
      min-width 0
      overflow hidden
    }
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .Ops {
      overflow hidden
    }
  }
  @media (max-width screenWidth) {
    .Ops {
      width 100vw
      min-width 0
      overflow hidden
    }
    .TabsBar {
      display none
    }
    .top {
      display none
    }
  }
</style>
